import { useCallback, useEffect, type ReactNode } from "react"
import { useHistory, useLocation } from "react-router-dom";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { useQuery } from "src/framework/commons/useQuery";
import { useObservable } from "src/framework/store/storeUtil";
import { AuthMethod } from "./types";
import { getOnlyURLParams } from "src/framework/commons/GetOnlyUrlParams";
import { isLoggedIn$, LoginStore, processandoToken$ } from "src/framework/store/LoginStore";

const LOGIN_TOKEN_KEY = "solar.loginToken";
export const RedirectLayout = ({ children }: { children: ReactNode }) => {
    const isLoggedIn = useObservable(isLoggedIn$);
    const processandoToken = useObservable(processandoToken$);
    const location = useLocation()
    const query = useQuery();
    const history = useHistory();

    const defineAuthMethod = useCallback(async (): Promise<AuthMethod | null> => {
        const tokenStorage = LocalStorage.get(LOGIN_TOKEN_KEY)
        if (tokenStorage) return AuthMethod.TOKEN_URL

        return null;
    }, [])

    const loginFromTokenUrl = useCallback(async(queryStr: string) => {
        const tokenStorage = LocalStorage.get(LOGIN_TOKEN_KEY)
        processandoToken$.next(true);
        await LoginStore.loginFromRedirect(tokenStorage).then(errorMessage => {
            processandoToken$.next(false);
            if (errorMessage) {
                //hasError = true
                console.error("Erro ao fazer login a partir do token:", errorMessage);
                LocalStorage.remove(LOGIN_TOKEN_KEY)
                window.location.href = `${window.location.origin}${window.location.pathname}`;
                return;
            }
        })
    }, [])
    useEffect(()=>{
        // Autenticação via token passado pela URL
        const tokenUrl = query.get("token")
        const tokenStorage = LocalStorage.get(LOGIN_TOKEN_KEY);
        if(!tokenUrl && !tokenStorage) {
            processandoToken$.next(false);
            return;
        }
        

        const allowedParams = [
            { localStorageKey: LOGIN_TOKEN_KEY, urlParam: "token", value: tokenUrl },
        ]

        if (allowedParams.find(item => !!item.value)) {
            for (const param of allowedParams) {
                if (param.value) {
                    LocalStorage.set(param.localStorageKey, param.value);
                    query.delete(param.urlParam);
                }
            }
            history.replace({
                search: query.toString()
            })
            
            return;
        }

        if (isLoggedIn === false) {
            defineAuthMethod().then(method => {
                switch (method) {
                case AuthMethod.TOKEN_URL:
                    const queryStr = getOnlyURLParams(location)
                    loginFromTokenUrl(queryStr).then(()=>{
                    })

                    break;
                }
            })
            return;
        }
    },[ history, isLoggedIn, location, loginFromTokenUrl, query, processandoToken])
    
    if (!isLoggedIn && (processandoToken === null || processandoToken)) return <></>
    return (
        <>
            {children}
        </>
    )
}
